import { render, staticRenderFns } from "./TimeDistance.vue?vue&type=template&id=56dcd4f6"
import script from "./TimeDistance.vue?vue&type=script&lang=js"
export * from "./TimeDistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports